import { Component, DoCheck, Injector, OnInit } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { CommonService } from 'src/app/@shared/services/common.service';
import { SharedService } from 'src/app/@shared/services/shared.service';
import { WebserviceService } from 'src/app/@shared/services/webservice.service';
import { DashboardComponent } from '../dashboard.component';

@Component({
  selector: 'app-d-dashboard',
  templateUrl: './d-dashboard.component.html',
  styleUrls: ['./d-dashboard.component.css']
})
export class DDashboardComponent extends DashboardComponent implements OnInit, DoCheck {
  public menuItems: any[] = [];
  public id: any;

  constructor(
    public service: WebserviceService,
    public _shared: SharedService,
    public _common: CommonService,
    public actRoute: ActivatedRoute,
    public router: Router,
    protected injector: Injector,
  ) {
    super(service, _shared, _common, actRoute, router, injector);
    this.constructorCallData();

    this._shared.sharedMenu.subscribe((res: any) => {
      if (res?.key == 'emitMenu') {
        this.menu = this.getLocalItem('menu');
        this.setMenu();
      }
    })
  }

  ngOnInit(): void {
    this.id = this.actRoute.snapshot.paramMap.get('id');
    this.getCasinoData();
    this.setMenu();
    // this.rout();
  }

  // rout() {
  //   this.router.events.subscribe((event: Event) => {
  //     if (event instanceof NavigationStart) {
  //       console.log(123);

  //       this.setMenu();
  //     }
  //   })
  // }

  setMenu() {
    if (this.actRoute.snapshot.paramMap.get('id')) {
      this.id = this.actRoute.snapshot.paramMap.get('id');
      if (this.menu != null && this.menu.length > 0)
        this.menu.forEach((element: any, i: number) => {
          if (element.id == this.actRoute.snapshot.paramMap.get('id')) {
            this.menuItems = [element];
            this.tabId = element.id;
          }
        });

      if (this.events.races.includes(Number(this.actRoute.snapshot.paramMap.get('id')))) {
        this.getRaceListData(this.actRoute.snapshot.paramMap.get('id'));
      } else if (!this.events.casino.includes(Number(this.actRoute.snapshot.paramMap.get('id')))) {
        this.getData();
      }

    } else {
      if (this.menu) {
        this.menu.forEach((element: any, i: number) => {
          if (!this.events.sportsBook.includes(element.id)) {
            this.menuItems = [...this.menuItems, ...[element]]
          }
        });
        // this.menuItems = this.menu;
        this.menuItems.unshift({ id: 'in_play', name: 'Inplay' })
        if (!this.events.casino.includes(Number(this.actRoute.snapshot.paramMap.get('id'))))
          this.getData();
      }
    }


  }
  ngDoCheck() {
    if (this.id && this.id != this.actRoute.snapshot.paramMap.get('id')) {
      this.id = this.actRoute.snapshot.paramMap.get('id');
      this.setMenu();
    }
  }

}
